import { type ReactNode } from 'react';

import { SmartFillTooltip } from '../../../../../fulfillment-plan/sections/configure-shipment/smartfill-tooltip';

import style from '../../packing-applied-classes.module.less';

type FieldLabelWithIndicatorsProps = {
  children: ReactNode;
  isPackingApplied: boolean;
  shouldShowSmartFillIcon: boolean;
  smartFillCount?: number;
};

export const FieldLabelWithIndicators = ({
  children,
  isPackingApplied,
  shouldShowSmartFillIcon,
  smartFillCount,
}: FieldLabelWithIndicatorsProps) => {
  if (isPackingApplied) {
    return <span className={style['packing-applied-label']}>{children}</span>;
  }

  if (shouldShowSmartFillIcon) {
    return (
      <SmartFillTooltip count={smartFillCount} shouldHideTooltip={false}>
        {children}
      </SmartFillTooltip>
    );
  }

  return <>{children}</>;
};
